<h5>Partidos</h5>

<div class="row">
  @for (game of games(); track game.id; let i = $index) {
    <div class="col-md-6 col-lg-4 col-xxxl-3">
      <game-ui
        [game]="game"
        [index]="i"
      ></game-ui>
    </div>
  }
</div>

